import styled from 'styled-components';

export const StyledFormGrid = styled.div`
  max-width: 1200px;
  width: 100%;
  ${({pt}) => pt && `padding-top: ${pt}px`};
  .grid-form__input {
    label {
      font-family: 'Open Sans', sans-serif;
    }
    input {
      font-size: 16px;
    }
    input[readonly] {
      opacity: 0.55;
    }
    & > div {
      background-color: rgba(229,227,236,0.5);
    }
  }
  @media screen and (max-width: 1920px) {
    max-width: 960px;
    margin: 0 auto;
  }
`;

export const StyledFormBlock = styled.div`
  margin-bottom: 50px;
  display: grid;
  grid-template-columns: 30% 40% 30%;
  &:last-child {
    margin-bottom: 0;
  }
  @media screen and (max-width: 1550px) {
    grid-template-columns: 30% 70%;
    .clear-column:last-child {
      display: none;
    }
  }
  @media screen and (max-width: 768px) {
    padding: 0 10%;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    .clear-column {
      display: none;
    }
  }
  @media screen and (max-width: 576px) {
    padding: inherit;
  }
`;

export const StyledBlockLabel = styled.div`
  color: #277661;
  font-size: 16px;
  font-weight: 600;
`;

export const StyledInputBlock = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 25px;
`;

export const StyledBlockAction = styled.div`
  height: 55px;
  button {
    height: 100%;
  }
  @media screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const StyledCheckbox = styled.div`
  text-align: ${({ position }) => (position === "center" ? "center" : "left")};
`;